var site;

site = site || {};

(function ($) {
  Drupal.behaviors.fragranceFinderResultsPanelV1 = {
    productsArray: page_data['custom-mpp'].products || [],
    initLoaded: false,
    attach: function (context) {
      var self = this;

      $(document).on('fragrance_finder_question_formatter:results_ready', function (e) {
        var $el = e.payload['$el'];
        var $carousel = $el.find(
          '.js-fragrance-finder-result-panel-products-item'
        );
        var $currentPanel = $carousel.closest('.js-fragrance-finder-result-panel');
        var slideCount;
        var isMobile = window.innerWidth < 1025;

        if ($carousel.length > 0) {
          slideCount = $carousel.children().length;
          if (!$carousel.hasClass('slick-initialized') &&
           ((isMobile && slideCount > 1) || (!isMobile && slideCount > 3))) {
            self.carouselInit($currentPanel, $carousel);
          } else {
            if ($carousel.hasClass('slick-initialized')) {
              setTimeout(function () {
                $carousel.slick('setPosition');
              }, 100);

            }
            self.initResults($currentPanel, true);
          }
        }
      });
    },
    setConfig: function ($product) {
      var self = this;

      $product.config = {};
      $product.config.productData = _.find(self.productsArray, function (p) {
        return p.PRODUCT_ID === $product.data('productId');
      });
    },
    getDom: function ($product) {
      $product.nodes = {};
      $product.nodes.image = $('.js-fragrance-finder-result__product-image', $product);
      $product.nodes.atb = $('.js-fragrance-finder-result-product-atb', $product);
      $product.nodes.skus = $('.js-fragrance-finder-result-product-skus', $product);
      $product.nodes.skuContainer = $('.js-fragrance-finder-result__product-skucontainer', $product);
      $product.nodes.selected = $('.js-fragrance-finder-result-product-skus--selected', $product.nodes.skus);
      $product.nodes.price = $product.nodes.skus
        .closest('.js-fragrance-finder-result-product')
        .find('.js-fragrance-finder-result-product-content--price');
      $product.nodes.reviews = $('.js-fragrance-finder-result-product-content--reviews', $product);
      $product.nodes.stars = $('.js-stars-simplified-stars', $product.nodes.reviews);
    },
    setInit: function ($product) {
      var starsWidth = 0;
      var starRating = 0;

      if ($product.nodes.skuContainer.children().length < 2) {
        $product.addClass('no-selector');
      }

      if ($product.nodes.reviews.length > 0) {
        starRating = parseInt($product.nodes.stars.data('starRating'), 10);
        starsWidth = (starRating / 5) * 100;
        $product.nodes.stars.css('width', starsWidth + '%');
      }
    },
    setProductListeners: function ($product) {
      var $sku;

      $product.nodes.selected.off('click.selected').on('click.selected', function () {
        $product.nodes.skus.toggleClass('active');
      });

      $product.nodes.skus
        .find('.js-fragrance-finder-result-product-sku')
        .off('click.skus').on('click.skus', function () {
          $sku = $(this);
          $product.nodes.selected.html($sku.html());
          $product.nodes.skus.removeClass('active');
          $product.nodes.skus
            .siblings('.js-add-to-cart')
            .attr('data-sku-base-id', $sku.data('skuId'));
          $product.nodes.price.html($sku.data('skuPrice'));
        });
    },
    initResults: function ($module, initLoad) {
      var self = this;
      var $products = $module.find('.js-fragrance-finder-result-product');

      $products.each(function () {
        var $product = $(this);

        self.getDom($product);
        self.setConfig($product);
        self.setInit($product);
        self.setCartInit($product);
        self.setProductListeners($product);
      });
    },
    setCartInit: function ($product) {
      var $atb;

      $('.js-add-to-cart', $product).each(function () {
        $atb = $(this);
        $atb.unbind();
        site.createAddButton($atb);
      });
    },
    carouselInit: function ($module, $carousel) {
      var self = this;
      var $results = $carousel.closest('.js-fragrance-finder-result-formatter');
      var mobileSlidesToShow = $results.data('mobileResultsTwo');

      $carousel.on('init', function () {
        $results.addClass('carousel-init');
        self.initResults($module, true);
        setTimeout(function () {
          $carousel.slick('setPosition');
        }, 100);
      });

      // Slick's breakpoint function is removing the slides' event listener. Restored with this.
      $carousel.on('breakpoint', function () {
        self.initResults($module, false);
      });

      $carousel.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 3,
        rtl: site.direction.isRTL,
        prevArrow:
          '<button class="fragrance-finder-result-panel__carousel-arrows slide-arrow slick-prev" aria-label="Previous" type="button" style="display: block;"><svg class="icon icon--arrow-left" style="fill:#040a2b;"><use xlink:href="#arrow-left"></use></svg></button>',
        nextArrow:
          '<button class="fragrance-finder-result-panel__carousel-arrows slide-arrow slick-next" aria-label="Next" type="button" style="display: block;"><svg class="icon icon--arrow-left" style="fill:#040a2b;"><use xlink:href="#arrow-right"></use></svg></button>',
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: mobileSlidesToShow ? 2 : 1
            }
          }
        ]
      });
    }
  };
})(jQuery);
